import { useMemo, useState } from "react"
import s from '../../../../commonStyles.modules.scss'
import { Tabs } from '@fullscreendigital/carrefour-dex-fe'
import ViewDetails from './ViewDetails/ViewDetails'
import Images from './Images/Images'
import { useLocation } from "react-router-dom"
import { InfoItems } from "../../../../../core-ui/InfoItems"
import { buildOrderInfoItems, FALLBACK } from "./helpers"

const OrderDetails = ({ isHistorical }) => {
  const location = useLocation()
  const { fromOrdersRow } = location.state || {}

  const [currentTab, setCurrentTab] = useState<number>(0)

  const infoItems = useMemo(() => {
    const built = buildOrderInfoItems(fromOrdersRow)

    if (built.length === 0) {
      return [
        { name: FALLBACK, label: 'Număr comandă:' },
        { name: FALLBACK, label: 'Magazin(e):' },
        { name: FALLBACK, label: 'Nume Furnizor:' },
        { name: FALLBACK, label: 'Status:' },
      ]
    }

    return built
  }, [fromOrdersRow])

  return (
    <div className={s.mainContainer}>
      <InfoItems itemsPerRow={3} items={infoItems} />
      <Tabs
        containerStyle={{}}
        tabContentBoxStyle={{
          padding: 0
        }}
        tabs={[
          {
            content: <ViewDetails isHistorical={isHistorical} />,
            label: 'Detalii comanda',
            tabIndex: 0
          },
          {
            content: <Images isHistorical={isHistorical} />,
            label: 'Imagini',
            tabIndex: 1
          }
        ]}
        tabsAriaLabel="Comenzi"
        tabsContainerStyle={{
          borderBottom: 1,
          marginBottom: '24px',
          borderColor: '#223fa0',
          '.MuiTabs-flexContainer': {
            '.MuiButtonBase-root': {
              maxWidth: 'fit-content'
            }
          }
        }}
        value={currentTab}
        onChange={(_, value) => setCurrentTab(value)}
      />
    </div>
  )
}

export default OrderDetails
